import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { AppState } from '../../../../../../app.service';
import { Service } from '../../../direct-connect.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../../common/global-variables';
let $ = require('jquery');
const _ = require('lodash');

@Component({
  selector: 'manage-uplink',
  styles: [require('../../../direct-connect.scss')],
  template: require('./manage-uplink.html'),
    providers: [
    Service, TranslateService
  ]
})

export class ManageUplink {


  @Input() isWizardOpen: boolean = false;
  @Input() uplinks: Object;
  @Input() newUplinks: Object;

  @Input() stepId: number;
  @Input() stepData: any;
  @Input() createData: any;
  @Output() stepEventEmitter: EventEmitter<any> = new EventEmitter();

  private isTranslationready: boolean = true;
  private allUplinks: Array<Object> = [];
  private dataModel = {
    uplinks: [],
    uplinksSelection: [],
    stepId: -1
  };
  private networkId: string = "";

  constructor(public appState: AppState,
              public service: Service,
              private translate: TranslateService) {
      translate.use(GlobalVariables.LOCALE);
   }

  ngOnChanges(changes) {
    if (this.stepId >= 0) {
      this.dataModel.stepId = this.stepId;
    }

    this.networkId = this.createData.network.id;
    if (this.uplinks) {
        this.allUplinks = [];
        this.allUplinks = (this.uplinks['gatewayInterfaces']) ? _.cloneDeep(this.uplinks['gatewayInterfaces']) : [];
        if (this.newUplinks) {
            this.allUplinks.push (this.newUplinks);
        }
    }

    if (this.allUplinks) {
        this.dataModel.uplinksSelection = [];
        for (let i = 0; i < this.allUplinks.length; i++) {
          this.dataModel.uplinksSelection.push ({id:this.allUplinks[i]['networkId'], name: this.allUplinks[i]['networkName'],  selected: true});
        }
        this.emitData();
    }
  }

  onCheckboxChange(event) {
    for (let i = 0; i < this.dataModel.uplinksSelection.length; i++) {
        if (this.dataModel.uplinksSelection[i].id === event.target.value) {
          this.dataModel.uplinksSelection[i].selected = event.target.checked
        }
    }
    this.emitData()
  }

  emitData() {
    this.stepEventEmitter.emit(this.dataModel);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/network/direct-connect/wizards/connect-gateway/steps/manage-uplink.component.ts